import type { LucideProps } from 'lucide-react';
import {
  Archive,
  BarChart3,
  ChevronRight,
  Gamepad2,
  Settings,
  Shield,
  Trophy,
  Volume2,
  VolumeX,
  Wallet,
  X
} from 'lucide-react';

export const icons = {
  archive: Archive,
  chart: BarChart3,
  chevron: ChevronRight,
  gamepad: Gamepad2,
  settings: Settings,
  shield: Shield,
  trophy: Trophy,
  volume: Volume2,
  muted: VolumeX,
  wallet: Wallet,
  close: X
};

export function Icon({
  name,
  ...props
}: LucideProps & { name: keyof typeof icons }) {
  const Component = icons[name];
  return <Component aria-hidden="true" {...props} />;
}

